<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              Location Details
            </h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>
                    Name
                  </td>
                  <td>
                    {{ locationModel.name ? locationModel.name : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Description
                  </td>
                  <td>
                    {{ locationModel.description ? locationModel.description : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Category
                  </td>
                  <td>
                    {{ locationModel.categoryName ? locationModel.categoryName : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Telephone Number
                  </td>
                  <td>
                    {{ locationModel.telephoneNumber ? locationModel.telephoneNumber : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Email Address
                  </td>
                  <td>
                    {{ locationModel.emailAddress ? locationModel.emailAddress : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Location
                  </td>
                  <td
                    v-html="
                      $options.filters.getMapsLink([
                        locationModel.location.coordinates[0],
                        locationModel.location.coordinates[1],
                      ])
                    "
                  ></td>
                </tr>
                <tr>
                  <td>
                    Full Address
                  </td>
                  <td>
                    {{ locationModel.fullAddress ? locationModel.fullAddress : 'Not Specified' }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Created By
                  </td>
                  <td>
                    {{ locationModel.createdBy ? locationModel.createdBy : 'Not Specified' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn v-if="$route.params.id == 0" color="primary" :to="`${$route.path}/edit`" class="mr-2"
              >Create a New Location</v-btn
            >
            <v-btn v-else color="primary" :to="`${$route.path}/edit`" class="mr-2">Edit</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Location } from '@/models/Location';
import { gql } from 'apollo-boost';
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      locationModel: new Location(),
      me: 'Not Specified',
      search: null,
      crumbs: [
        {
          text: 'Locations',
          disabled: false,
          href: '/admin/locations',
        },
        {
          text: 'Location Details',
          disabled: true,
          href: `/admin/location/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    location: {
      query: gql`
        query Location($id: ID!) {
          location(id: $id) {
            id
            name
            description
            category
            categoryName
            telephoneNumber
            emailAddress
            location
            fullAddress
            createdBy
            createdByUsername
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: 'network-only',
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        console.log('got data');
        this.isLoading = false;
        this.locationModel.id = this.location.id;
        this.locationModel.name = this.location.name;
        this.locationModel.description = this.location.description;
        this.locationModel.category = this.location.category;
        this.locationModel.categoryName = this.location.categoryName;
        this.locationModel.telephoneNumber = this.location.telephoneNumber;
        this.locationModel.emailAddress = this.location.emailAddress;
        this.locationModel.location = this.location.location;
        this.locationModel.fullAddress = this.location.fullAddress;
        this.locationModel.createdBy = this.location.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
